module.exports = __webpack_public_path__ + "img/11.7e9b25a5.jpg";